// @ts-nocheck
import React, { useRef, useState } from "react";
import {useHistory} from "react-router-dom";
import dayjs from 'dayjs';

let countdownInterval;
let timeout;

const SessionTimeout = ({user,logOut}) => {
    const [events, setEvents] = useState(['click', 'load', 'scroll']);
    const [second, setSecond] = useState(0);
    let timeStamp;
    let warningInactiveInterval = useRef();
    let startTimerInterval = useRef();

    let history = useHistory();

    let timeChecker = () => {
        startTimerInterval.current = setTimeout(() => {
            let storedTimeStamp = sessionStorage.getItem('lastTimeStamp');
            warningInactive(storedTimeStamp);
        }, 900000);
    };

    // reset interval timer
    let resetTimer = React.useCallback(() => {
        clearTimeout(startTimerInterval.current);

        if (user !== null) {
            timeStamp = dayjs().toISOString();
            sessionStorage.setItem('lastTimeStamp', timeStamp);
        } else {
            clearInterval(warningInactiveInterval.current);
            sessionStorage.removeItem('lastTimeStamp');
        }

        timeChecker();
    }, []);

    // Life cycle hook
    React.useEffect(() => {
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });
        // Run the timeChecker
        timeChecker();

        return () => {
            clearTimeout(startTimerInterval.current);
        };
    }, [resetTimer, events, timeChecker]);

    let warningInactive = (timeString) => {
        clearTimeout(startTimerInterval.current);

        warningInactiveInterval.current = setInterval(() => {
            const maxTime = 2; // Maximum ideal time given before logout
            const popTime = 1; // remaining time (notification) left to logout.

            const diffMs = dayjs().diff(dayjs(timeString));
            const minPast = Math.floor(diffMs / 60000);
            const leftSecond = 60 - Math.floor((diffMs % 60000) / 1000);

            if (minPast === popTime) {
                setSecond(leftSecond);
            }

            if (minPast === maxTime) {
                clearInterval(warningInactiveInterval.current);
                sessionStorage.removeItem('lastTimeStamp');
                logOut()
                history.push('/login')
            }
        }, 1000);
    };

    return (
        <React.Fragment />
    );
}

export default SessionTimeout;